var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    attrs: {
      headers: _vm.headers,
      items: _vm.bookings,
      search: _vm.search,
      "sort-by": _vm.pagination.sortBy,
      "sort-desc": _vm.pagination.descending,
      "custom-filter": _vm.filterOverAllProperty,
      "items-per-page": 5,
      loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item",
          fn: function(props) {
            return [
              _c("tr", [
                _c("td", {}, [
                  _vm._v(_vm._s(_vm.formatDateView(props.item.creation_date)))
                ]),
                _c(
                  "td",
                  [
                    _vm._v(" " + _vm._s(props.item.reservation_number) + " "),
                    props.item.is_cancelled === 1
                      ? _c(
                          "v-chip",
                          {
                            staticStyle: {
                              color: "#FFE3F3",
                              "background-color": "#ff99d0 !important"
                            },
                            attrs: { small: "", label: "", outlined: "" }
                          },
                          [_vm._v(_vm._s(_vm.$t("booking.canceled")) + " ")]
                        )
                      : _vm._e(),
                    _c("assigned-delegations-chip", {
                      attrs: { delegations: props.item.delegations }
                    })
                  ],
                  1
                ),
                _c("td", { staticClass: "py-2" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { staticClass: "flight-part" }, [
                            _c("div", { staticClass: "flight-airport" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "bigger",
                                  staticStyle: { "font-weight": "bold" }
                                },
                                [
                                  _c("span", { staticClass: "accent--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        props.item.railAttributes.itinerary_from
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "arrow" }, [
                                    _vm._v("➞")
                                  ]),
                                  _c("span", { staticClass: "accent--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        props.item.railAttributes.itinerary_to
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c("br"),
                              props.item.railAttributes.start_time != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        props.item.railAttributes.start_time.substr(
                                          0,
                                          5
                                        )
                                      ) + " "
                                    )
                                  ])
                                : _vm._e(),
                              props.item.railAttributes.end_time != null
                                ? _c("span", [
                                    _vm._v(
                                      " - " +
                                        _vm._s(
                                          props.item.railAttributes.end_time.substr(
                                            0,
                                            5
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            props.item.railAttributes.start_date != null
                              ? _c(
                                  "div",
                                  { staticClass: "flight-date grey--text" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.dayOfWeek(
                                            props.item.railAttributes.start_date.substr(
                                              0,
                                              10
                                            )
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.formatDateView(
                                            props.item.railAttributes.start_date
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("td", {}, [
                  _vm._v(_vm._s(props.item.railAttributes.ticket_number))
                ]),
                _c("td", { staticClass: "flight-airport" }, [
                  _c("span", { staticClass: "accent--text bigger" }, [
                    _vm._v(_vm._s(props.item.railAttributes.carrier))
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "booking.class" +
                            props.item.railAttributes.class_of_booking
                        )
                      ) +
                      " "
                  )
                ]),
                _c(
                  "td",
                  {},
                  _vm._l(props.item.passengers, function(passenger) {
                    return _c(
                      "span",
                      { staticStyle: { "text-transform": "capitalize" } },
                      [_vm._v(" " + _vm._s(passenger) + " "), _c("br")]
                    )
                  }),
                  0
                ),
                _c(
                  "td",
                  { staticClass: "datatable-total-amount" },
                  [
                    props.item.invoice_gross_value !== null
                      ? [
                          _vm._v(
                            _vm._s(props.item.invoice_gross_value) +
                              " " +
                              _vm._s(props.item.invoice_currency)
                          )
                        ]
                      : props.item.total_amount !== null
                      ? [_vm._v(_vm._s(props.item.total_amount) + " PLN")]
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "td",
                  { staticClass: "text-center text-no-wrap" },
                  [
                    _vm._t(
                      "action-column",
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "mx-0",
                                            attrs: {
                                              to:
                                                "/booking/other/detail/" +
                                                props.item.id,
                                              icon: ""
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("remove_red_eye")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.goToDetails")) + " "
                            )
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "mx-0",
                                            attrs: {
                                              disabled:
                                                _vm.$store.getters[
                                                  "Ajax/loading"
                                                ],
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadAttachment(
                                                  props.item.id
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("cloud_download")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                            )
                          ]
                        )
                      ],
                      { booking: props.item }
                    )
                  ],
                  2
                )
              ])
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }